import { Outlet } from "react-router-dom";
import React, { useState } from "react";

function Vendors() {
  const [vendor, setVendor] = useState({});
  const [isEdit, setIsEdit] = useState({
    disabled: false,
    edit: false,
  });
  return <Outlet context={{ vendor, setVendor, setIsEdit, isEdit }} />;
}

export default Vendors;
